import type { ReactNode } from 'react';

export const symbol_content_paste_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M810.18-238q-11.18 0-20.68-7.68-9.5-7.69-9.5-22.32v-512h-60v60q0 12.75-8.62 21.37Q702.75-690 690-690H380q-12.44 0-23.72-5t-19.44-13.16L256-789q-5-5-7-10.5t-2-10.83q0-10.67 8-20.17 8-9.5 22-9.5h105q7-35 34.5-57.5T480-920q36 0 63.5 22.5T578-840h202q26 0 43 17t17 43v512q0 15-9.32 22.5t-20.5 7.5ZM508.5-791.5Q520-803 520-820t-11.5-28.5Q497-860 480-860t-28.5 11.5Q440-837 440-820t11.5 28.5Q463-780 480-780t28.5-11.5ZM694-180 180-694v514h514Zm-514 60q-26 0-43-17t-17-43v-574l-38-38q-9-9.07-9-21.53Q73-826 82.05-835q9.06-9 21.5-9 12.45 0 21.45 9l710 710q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q801-74 792-83l-38-37H180Z"
		/>
	</svg>
);
